export { Carousel, type CarouselProps } from './Carousel';
